import React, { Component } from 'react';
import LocElement from './LocElement';

class SecHeadline extends Component
{
  render() {
    return (
      <div className="second-head">
        { this.props.example ? (<span className="xmpl"><LocElement {...this.props.example[0].exampleHeadline}/></span>) : null }
        <h2><LocElement {...this.props.text}/></h2>
      </div>
    );
  }
}

export default SecHeadline
